import React from "react";
import { useTranslation } from "react-i18next";

function Download() {
  const { t } = useTranslation();

  return (
    <div className="container mx-auto px-4">
      <div className="bg-transparent p-10 md:p-20 rounded-md shadow-lg text-center">
        <h3 className="text-2xl md:text-4xl font-bold mb-4">
          {t("download.title")}
        </h3>
        <p className="text-lg font-semibold mb-8 bg-gradient-to-r from-black via-gray-400 to-gray-800 text-transparent bg-clip-text animate-shine">
          {t("download.subtitle")}
        </p>
        <div className="flex flex-col md:flex-row items-center justify-center gap-6">
          <img
            src="/images/play-store.png"
            alt={t("download.playStoreAlt")}
            className="w-48 md:w-56"
          />
          <img
            src="/images/app-store.png"
            alt={t("download.appStoreAlt")}
            className="w-48 md:w-56"
          />
        </div>
      </div>
    </div>
  );
}

export default Download;
